import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoresDashboardQuerySchema } from '~/services/api/generated'

// Dashboard\StoreIndexRequest::rules
export const StoresDashboard = (_context: NoContext = {}) => StoresDashboardQuerySchema
